
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"d":"M4.46 10c-.2 0-.3-.1-.3-.28V6.55c0-.03-.02-.06-.06-.08-.02-.02-.05-.02-.09 0l-3 1.67a.34.34 0 01-.15.02.3.3 0 01-.26-.14l-.56-.96A.3.3 0 010 6.92c0-.11.05-.2.15-.25l3.03-1.59c.04-.01.06-.04.06-.08s-.02-.07-.06-.08L.16 3.33A.26.26 0 010 3.16a.3.3 0 01.03-.22l.56-.96c.04-.08.1-.13.18-.14.07-.02.15-.01.23.02L4 3.5c.04.02.07.02.1 0s.05-.04.05-.08V.28c0-.19.1-.28.3-.28h1.11c.2 0 .3.1.3.28v3.14c0 .04 0 .06.03.08.04.02.08.02.12 0l3-1.64a.34.34 0 01.15-.02c.11 0 .2.04.26.14l.53.96a.3.3 0 01.03.14c0 .11-.05.2-.15.25L6.81 4.92c-.04.01-.06.04-.06.08s.02.07.06.08l3.03 1.59c.08.03.13.1.15.17a.3.3 0 01-.03.22l-.53.96a.26.26 0 01-.18.14.34.34 0 01-.23-.02l-3-1.67a.13.13 0 00-.12 0c-.02.02-.03.05-.03.08v3.17c0 .19-.1.28-.3.28H4.46z","fill":"#5B5858"}})])
          )
        }
      }
    